export async function base64FromPath(path: string, blob: any = null): Promise<string> {
  if(!blob) {
    const response = await fetch(path);
    blob = await response.blob();
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      } else {
        reject('method did not return a string');
      }
    };
    reader.readAsDataURL(blob);
  });
}